module.exports = __webpack_public_path__ + "img/scene-gov.0ac8668b.jpg";